import { defineComponent, computed } from 'vue';
import { useAccountStore } from 'src/stores/account';
import standardAvatar from 'src/components/image/standardAvatar.vue';
export default defineComponent({
    name: 'photo-button',
    props: {
        size: {
            type: String,
            default: '1.1rem'
        },
        avatarSize: {
            type: String,
            default: '3rem'
        },
        pic: String,
        disableBadge: Boolean,
        noPaddings: Boolean
    },
    emits: ['click'],
    components: {
        standardAvatar
    },
    setup() {
        const accountStore = useAccountStore();
        const user = computed(() => accountStore.user);
        return { user };
    }
});
